import * as React from "react";

import { GoogleTagManager } from "../GoogleTagManager";
import { useLocation } from "react-router-dom";

const LOGIN_PATHS = [
  "/login",
  "/password-login",
  "/sign-up",
  "/password/request-password-reset",
  "/password/reset-link-sent",
  "/password/reset",
  "/check-your-email",
];

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const isMarketingPage = !LOGIN_PATHS.includes(pathname);

  return (
    <div
      className={`tw-relative tw-z-10 tw-flex-grow tw-bg-white tw-bg-[length:100%_100%] tw-bg-[0px_0px] tw-bg-no-repeat tw-text-[16px]`}
    >
      {isMarketingPage && <GoogleTagManager />}
      <div>{children}</div>
    </div>
  );
};
